import { FetchIntegration, FetchIntegrationDropdown } from "api";
import { SchoolIDState } from "global-states";
import { Class, Year } from "models";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue, atom, useRecoilState } from "recoil";
import { IntegrationPayload } from "./types";

export const IntegrationYearIDState = atom<string>({
  key: "integration/yearID",
  default: "",
});

export const IntegrationClassIDState = atom<string>({
  key: "integration/classID",
  default: "",
});

export default function useIntegration() {
  const { search } = useLocation();
  const [allOptions, setAllOptions] = useState<Class[]>([]);
  const [yearOptions, setYearOptions] = useState<Year[]>([]);
  const [classOptions, setClassOptions] = useState<Class[]>([]);
  const schoolID = useRecoilValue(SchoolIDState);
  const [yearID, setYearID] = useRecoilState(IntegrationYearIDState);
  const [classID, setClassID] = useRecoilState(IntegrationClassIDState);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<IntegrationPayload | undefined>(undefined);
  const [error, setError] = useState("");

  useEffect(() => {
    if (search.includes("grade_id")) {
      setYearID(search.replaceAll("?grade_id=", ""));
    }
  }, [search, setYearID]);

  useEffect(() => {
    FetchIntegrationDropdown(schoolID)
      .then((res) => setAllOptions(res.data))
      .catch((err) => console.error(err));
  }, [schoolID]);

  useEffect(() => {
    if (!allOptions || !allOptions.length) {
      setYearOptions([]);
      return;
    }
    const yearmap: { [key: string]: boolean } = {};
    const years: string[] = [];
    allOptions.forEach((cls) => {
      const year = cls.class_name.split("")[0];
      if (!yearmap[year]) {
        yearmap[year] = true;
        years.push(year);
      }
    });
    if (!years || !years.length) return;
    setYearOptions(years.map((year) => ({ year_id: year })));
    if (yearID === "") {
      setYearID(years[0]);
    }
  }, [allOptions, setYearID, yearID]);

  useEffect(() => {
    if (!yearOptions.length || yearID === "") {
      return;
    }
    const yearClasses = allOptions.filter(
      (cls) => cls.class_name.split("")[0] === yearID
    );
    if (!yearClasses || !yearClasses.length) return;
    setClassOptions(yearClasses);
    setClassID(yearClasses[0].class_id);
  }, [allOptions, setClassID, yearID, yearOptions.length]);

  useEffect(() => {
    if (yearID === "" || classID === "") {
      setData(undefined);
      return;
    }
    setIsLoading(true);
    FetchIntegration(yearID, classID)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => setError(JSON.stringify(err)))
      .finally(() => setIsLoading(false));
  }, [classID, yearID]);
  return { data, error, yearOptions, classOptions, isLoading };
}
